import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Modal,
  ScrollArea,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconMessageCircle,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import {
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";

// Interface cho dữ liệu mới từ API TblChiTietDonHang
interface TblChiTietDonHang {
  id: string;
  tenKhachHang: string;
  soDienThoai: string;
  diaChi: string;
  tenSanPham: string;
  maSanPham: string | null;
  gia: number;
  attribute1: string | null;
  attribute2: string | null;
  attribute3: string | null;
  attribute4: string | null;
  attribute5: string | null;
  attribute6: string | null;
  attribute7: number | null;
  attribute8: number | null;
  attribute9: number | null;
  attribute10: number | null;
  createdDate: string | null;
  createdBy: number | null;
  lastUpdatedDate: string | null;
  lastUpdatedBy: number | null;
}

// Interface cho Chat History
interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  parts: Array<{
    type: "text";
    text: string;
  }>;
  metadata: {
    createdAt: string;
  };
}

interface ChatHistoryResponse {
  success: boolean;
  data: {
    chatId: string;
    messageCount: number;
    messages: ChatMessage[];
    rawMessages: ChatMessage[];
  };
}

const OrderListAI = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [datas, setDatas] = useState<TblChiTietDonHang[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [chatHistory, setChatHistory] = useState<ChatMessage[]>([]);
  const [chatLoading, setChatLoading] = useState(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";


  const columns = React.useMemo<MRT_ColumnDef<TblChiTietDonHang>[]>(
    () => [
      {
        accessorKey: "tenKhachHang",
        header: "Tên khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "soDienThoai",
        header: "SĐT khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "diaChi",
        header: "Địa chỉ",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenSanPham",
        header: "Tên sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maSanPham",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue || "N/A"}</>,
      },
      {
        accessorKey: "gia",
        header: "Giá",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "attribute1",
        header: "Link sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue ? (
              <a 
                href={String(renderedCellValue)} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: '#1976d2', textDecoration: 'underline' }}
              >
                Xem sản phẩm
              </a>
            ) : (
              "N/A"
            )}
          </>
        ),
      },      {
        accessorKey: "attribute2",
        header: "Ghi chú",
        Cell: ({ renderedCellValue }) => (
          <>{renderedCellValue || "N/A"}</>
        ),
      },
      {
        accessorKey: "createdDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 100,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Xem lịch sử chat">
              <ActionIcon
                variant="light"
                aria-label="Xem chat"
                color="blue"
                onClick={() => {
                  const chatId = row.original.attribute3;
                  if (chatId) {
                    viewChatHistory(chatId);
                  } else {
                    NotificationExtension.Warn("Không có ID chat để xem lịch sử!");
                  }
                }}
              >
                <IconMessageCircle size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
    },
  });



  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  // Hàm gọi API lịch sử chat (không xác thực)
  const fetchChatHistory = async (chatId: string) => {
    setChatLoading(true);
    try {
      const response = await fetch(
        `https://tu-van-dev.hacom.vn/api/history-chat?id=${chatId}&secret=12345`,
        {
          method: 'GET',
        
        }
      );

      if (!response.ok) {
        console.warn(`HTTP status: ${response.status} - ${response.statusText}`);
      }

      const data: ChatHistoryResponse = await response.json();
      if (data?.success && data?.data?.messages) {
        setChatHistory(data.data.messages);
        return data.data.messages;
      }
      NotificationExtension.Warn("Không thể tải lịch sử chat!");
      return [];
    } catch (error) {
      console.error("Error fetching chat history:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi tải lịch sử chat!");
      return [];
    } finally {
      setChatLoading(false);
    }
  };

  // Hàm hiển thị modal lịch sử chat
  const viewChatHistory = async (chatId: string) => {
    const messages = await fetchChatHistory(chatId);
    if (messages.length > 0) {
      modals.open({
        title: <Title order={4}>Lịch sử chat</Title>,
        size: "xl",
        children: (
          <ScrollArea style={{ height: 700 }}>
            <Box style={{ padding: "10px" }}>
              {messages.map((message: ChatMessage, index: number) => (
                <Box
                  key={message.id}
                  style={{
                    marginBottom: "15px",
                    padding: "10px",
                    backgroundColor: message.role === "user" ? "#f0f8ff" : "#f5f5f5",
                    borderRadius: "8px",
                    borderLeft: message.role === "user" ? "4px solid #1976d2" : "4px solid #4caf50",
                  }}
                >
                  <Text size="sm" fw={500} c={message.role === "user" ? "blue" : "green"}>
                    {message.role === "user" ? "Khách hàng" : "AI Tư vấn"}
                  </Text>
                  <Text size="sm" c="dimmed" style={{ marginBottom: "8px" }}>
                    {new Date(message.metadata.createdAt).toLocaleString("vi-VN")}
                  </Text>
                  <Text size="sm" style={{ whiteSpace: "pre-wrap" }}>
                    {message.parts[0]?.text || ""}
                  </Text>
                </Box>
              ))}
            </Box>
          </ScrollArea>
        ),
      });
    }
  };
  // Bỏ Export Excel
  const table = useMantineReactTable({
    columns,
    data: datas || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["tenKhachHang"],
        right: ["action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      pagination,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);


  //#region Fetch data

  const fetchDataChiTietDonHang = async (
    index: number,
    size?: number,
    KeySearch?: string
  ) => {
    setLoading(true);
    setDatas([]);
    setError(undefined);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `/TblChiTietDonHang/get-list?Skip=${
        index * (size ?? 0)
      }&Take=${size}`;
      
      if (KeySearch && KeySearch.trim() !== "") {
        urlSearch += `&KeySearch=${encodeURIComponent(KeySearch)}`;
      }

      let callapi = await repository.get<MessageResponse<TblChiTietDonHang[]>>(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setRowCount(0);
        setDatas([]);
      } else {
        setDatas(callapi?.data || []);
        setPagination({
          ...pagination,
        });
        setRowCount(callapi?.totalCount ?? 0);
        return callapi?.data || [];
      }
      return [];
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          KeySearch: formSeachInput.getValues().KeySearch,
        })
      );
    }
  };

  const fetchData = async () => {
    await fetchDataChiTietDonHang(
      pagination.pageIndex,
      pagination.pageSize,
      formSeachInput.getValues().KeySearch
    );
  };

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={8}>
            <Input
              size="sm"
              placeholder="Tìm kiếm theo tên khách hàng, sản phẩm, địa chỉ..."
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
              fullWidth
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default OrderListAI;
